export default __webpack_public_path__ + "f86952265d7b0f02c92113735856b0a4.woff2";